import { useQuery } from 'apollo-3';

import { getFreeTrialCourses } from 'GraphQL/query/Enrollment.query';

const useGetFreeTrialCourses = ({ ...props }) => {
  const { data, loading, error, ...apolloUtils } = useQuery(getFreeTrialCourses, {
    ...props,
  });

  return {
    data: {
      courses: data?.erGetFreeTrialCourses?.courses,
    },
    loading,
    error,
    ...apolloUtils,
  };
};

export default useGetFreeTrialCourses;
